import axios from "axios";

const URL_API_TICKET = process.env.VUE_APP_API_CONTENIDO + "ticket/";

export default {
  cargarTickets(id_usuario, tipo_consulta) {
    return axios.get(
      URL_API_TICKET + `userTickets/${id_usuario}/${tipo_consulta}`
    );
  },
  contadorTickets(id_usuario, tipo_consulta) {
    return axios.get(
      URL_API_TICKET + `countTickets/${id_usuario}/${tipo_consulta}`
    );
  },
  ticketQA(id_usuario) {
    return axios.get(URL_API_TICKET + `getUserTicketsQA/${id_usuario}`);
  },
  cargarTicketsFiltrados(id_sucursal, params) {
    return axios.get(URL_API_TICKET + `filterTickets/${id_sucursal}`, {
      params,
    });
  },
  getSeleccionables(accion, params) {
    if (params)
      return axios.get(URL_API_TICKET + `ticketSelects/${accion}`, {
        params,
      });
    else return axios.get(URL_API_TICKET + `ticketSelects/${accion}`);
  },
  getEstadoQA(form) {
    return axios.get(
      URL_API_TICKET + `ticketStates/${form.id_ticket}/${form.tipo_consulta}`
    );
  },
  getHistorico(id_ticket) {
    return axios.get(URL_API_TICKET + `ticketComments/${id_ticket}`);
  },
  getArchivos(id_ticket, id_doc, id_usuario) {
    if (!id_doc) return axios.get(URL_API_TICKET + `ticketFiles/${id_ticket}`);
    else
      return axios.get(URL_API_TICKET + `ticketFiles/${id_ticket}/${id_doc}`);
  },

  solicitarTicket(form) {
    return axios.post(URL_API_TICKET + "createTicket", form);
  },
  guardarQA(form) {
    return axios.put(URL_API_TICKET + "updateTicket", form);
  },
  updateMultiple(form) {
    return axios.put(URL_API_TICKET + "updateTicketMultiple", form);
  },
  subirArchivo(form) {
    return axios.post(URL_API_TICKET + "uploadTicketFile", form);
  },
};
